// plugins/colorPlugin.ts
import React from 'react';
import { ColorPickerField } from '@react-page/editor';
import { pluginFactories } from '@react-page/plugins-slate';

const colorPlugin = pluginFactories.createComponentPlugin<{
  color: string;
}>({
  addHoverButton: true,
  addToolbarButton: true,
  type: 'SetColor',
  object: 'mark',
  icon: <span style={{ color: 'blue' }}>A</span>,
  label: 'Text Color',
  Component: 'span',
  getStyle: ({ color }) => ({ color }),
  controls: {
    type: 'autoform',
    schema: {
      type: 'object',
      required: ['color'],
      properties: {
        color: {
          type: 'string',
          default: 'rgba(0,0,255,1)',
          uniforms: {
            component: ColorPickerField,
          },
        },
      },
    },
  },
});

export default colorPlugin;
